import { Component, ChangeDetectionStrategy, HostListener, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { DropdownOption } from 'projects/shared/src/lib/core/interfaces/dropdown';

@Component({
  selector: 'tar-dropdown-menu',
  templateUrl: './dropdown-menu.component.html',
  styleUrl: './dropdown-menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslatePipe],
})
export class DropdownMenuComponent {
  public options = input<DropdownOption[]>([]);
  public title = input<string | null>('');
  public titleIcon = input<string | null>('');

  public isOpen = false;
  public highlightedIndex = -1;

  constructor() {}

  public toggleDropdownMenu() {
    this.isOpen = !this.isOpen;
    if (!this.isOpen) {
      this.highlightedIndex = -1;
    }
  }

  public onAction(action?: () => void) {
    action?.();
    this.closeMenu();
  }

  public closeMenu() {
    this.isOpen = false;
    this.highlightedIndex = -1;
  }

  @HostListener('document:click', ['$event'])
  public closeOnClickOutside(event: MouseEvent) {
    const clickedInsideDropdown = (event.target as HTMLElement).closest('.dropdown');
    if (!clickedInsideDropdown && this.isOpen) {
      this.closeMenu();
    }
  }
}
